import { Link } from 'react-router-dom';
import config from '../config';
import BrandMark from '../components/BrandMark';

export default function LandingPage() {
  return (
    <div className="shell">
      <BrandMark />
      <h1 className="hero-title">Payroll for the service industry.</h1>
      <p className="lede">
        Run hourly wages and tips &amp; gratuity payroll for your team. Connect a Bistro store when you have one,
        or use Payroll as a standalone product with your own employees.
      </p>
      <div className="cta-row">
        <Link className="btn btn-primary" to="/login">Sign in</Link>
        <Link className="btn btn-secondary" to="/signup">Create Payroll account</Link>
        <a className="btn btn-ghost" href={config.bistroAdminUrl}>Open BistroAdmin</a>
      </div>
    </div>
  );
}
